import { Box, Container, Divider, Grid, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

import ContactCustomerService from "components/auth/ContactCustomerService";
import ResetPasswordForm from "components/auth/ResetPasswordForm";
import { colors } from "theme";

const useStyles = makeStyles((theme: Theme) => ({
  divider: {
    background: colors.grey[400],
  },
}));

const ResetPassword = () => {
  const classes = useStyles();

  return (
    <Box width={1}>
      <Container>
        <Box
          pt={{ xs: 1.5, sm: 5, md: 6 }}
          pb={{ xs: 4, sm: 8, md: 10 }}
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={10} sm={8} md={5} xl={6}>
            <Grid container direction="column" alignItems="center">
              <ResetPasswordForm />
              <Box my={{ xs: 4.5, md: 3 }} width={1}>
                <Divider className={classes.divider} />
              </Box>
              <ContactCustomerService />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default ResetPassword;
